import React from 'react';
import { useAgreementTemplateQuery, useProviderLicensesStatusQuery, useStateQuery } from '@uplift/queries';
import { StateExhibitExpiring } from '@uplift/api';
import { ErrorOutline } from '@mui/icons-material';
import { useCurrentuser } from '@uplift/contexts';
import { DocumentListItemRow } from './DocumentListItemRow';


export const StateExhibitExpiringListItem: React.VFC<{
  document: StateExhibitExpiring;
  onClick: () => void;
  selected: boolean;
}> = ({
  document,
  onClick,
  selected,
}) => {
  const me = useCurrentuser();
  const { data: template } = useAgreementTemplateQuery(document.agreementTemplateId);
  const { data: licenses } = useProviderLicensesStatusQuery(me.id, { suspense: true });
  const license = licenses?.find(l => l.id === document.licenseId);
  const { data: state } = useStateQuery(license?.stateId, { suspense: true });

  return (
    <DocumentListItemRow
      name={template.name}
      status={`${state?.fullName ?? 'This'} state exhibit expiring soon — renew now to avoid potential disruptions.`}
      statusColor="warning"
      icon={<ErrorOutline />}
      onClick={onClick}
      selected={selected}
    />
  );
};
